import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";

import { usePipelineConfigSync } from "../../common/hooks/usePipelineConfigSync";
import { logError } from "../../utils/error";
import { useAuth } from "../auth/AuthContext";
import { AccountAnalysisTabs } from "./components/AccountAnalysisTabs";
import { SyncStatusPanel } from "./components/configuration/SyncStatusPanel";
import { useAccountAnalysisStore } from "./store/accountAnalysisStore";

export const AccountAnalysisPage: React.FC = () => {
  const { tenantId } = useAuth();
  const { syncEnabled } = usePipelineConfigSync();
  const {
    fetchEntities,
    fetchProfiles,
    fetchLensGroups,
    fetchConfiguration
  } = useAccountAnalysisStore();

  useEffect(() => {
    const loadData = async () => {
      try {
        await Promise.all([
          fetchEntities(),
          fetchProfiles(),
          fetchConfiguration()
        ]);
        if (tenantId) {
          await fetchLensGroups(tenantId);
        }
      } catch (error) {
        logError("Failed to load account analysis data", error);
      }
    };

    loadData();
  }, [
    fetchEntities,
    fetchProfiles,
    fetchConfiguration,
    fetchLensGroups,
    tenantId
  ]);

  return (
    <Box sx={{ p: 1 }}>
      <Box mb={4} display="flex" alignItems="flex-start" justifyContent="space-between">
        <Box>
          <Typography variant="h4" component="h1" gutterBottom>
            Account Analysis Configuration
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Manage analysis settings, groups, and people assignments for your
            organization
          </Typography>
        </Box>
        {syncEnabled && (
          <Box sx={{ mt: 1 }}>
            <SyncStatusPanel />
          </Box>
        )}
      </Box>
      <AccountAnalysisTabs />
    </Box>
  );
};
